import { sydneyToday } from "@artemis-group/aiw-contracts";
import type { InstallerJob } from "./types";

/** The installation summary date may be stale or belong to another crew.
 * The portal's assigned-day list is already permission filtered by the server. */
export function withAssignedDate(job: InstallerJob, today = sydneyToday()): InstallerJob {
  const dates = (job.days ?? []).filter((d) => !d.done_at).map((d) => d.date).filter((d) => /^\d{4}-\d{2}-\d{2}$/.test(d)).sort();
  const current = dates.find((d) => d >= today) ?? dates.at(-1) ?? null;
  return { ...job, install_next_date: current };
}
